import { render } from "./UtmConfig.vue?vue&type=template&id=aa8868a6&scoped=true"
import script from "./UtmConfig.vue?vue&type=script&lang=ts"
export * from "./UtmConfig.vue?vue&type=script&lang=ts"

import "./UtmConfig.vue?vue&type=style&index=0&id=aa8868a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aa8868a6"

export default script